import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useToast } from '@/shared/ui-kit/ToastProvider/useToast';

/** Возврат из мок-редиректа OAuth */
export function OAuthMockCallbackListener() {
  const location = useLocation();
  const navigate = useNavigate();
  const { showSuccess } = useToast();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('oauth_mock') !== '1') return;

    const state = params.get('state') ?? '';
    const toastKey = `oauth_mock_toast:${state}`;
    if (!sessionStorage.getItem(toastKey)) {
      sessionStorage.setItem(toastKey, '1');
      const provider = params.get('provider') ?? '';
      let label = provider || 'провайдер';

      if (provider === 'yandex') {
        label = 'Яндекс ID';
      }

      if (provider === 'vk') {
        label = 'VK ID';
      }
      showSuccess(`Мок OAuth, успешно ${label}`);
    }

    params.delete('oauth_mock');
    params.delete('provider');
    params.delete('state');
    params.delete('return');
    const next = params.toString();

    navigate(
      {
        pathname: location.pathname,
        search: next ? `?${next}` : '',
        hash: location.hash,
      },
      { replace: true }
    );
  }, [
    location.hash,
    location.pathname,
    location.search,
    navigate,
    showSuccess,
  ]);

  return null;
}
